import { Search } from '@mui/icons-material'
import { IconButton, Paper } from '@mui/material'
import React, { useState } from 'react'
import {  useNavigate } from 'react-router'

const SearchBar = () => {
  const [searchTerm, setSearchTerm]=useState("")
  const navigate=useNavigate()
  function HandelSubmit(e){
    e.preventDefault()
    if(searchTerm){
    navigate(`/search/${searchTerm}`)
    setSearchTerm("")
    }
  }
  
  return (
    <div>
      <Paper component="form" onSubmit={HandelSubmit} sx={{borderRadius:20,border:"1px solid #e3e3e3",pl:3,boxShadow:"none",mr:{sm:5},display:"flex" }}>
      
        <input name="search-bar" id="" onChange={(e)=>setSearchTerm(e.target.value)} className="outline-none" />
        <IconButton  type='submit' sx={{p:"10px",color:"red"}}>
          <Search/>
        </IconButton>
      </Paper>
    </div>
  )
}

export default SearchBar
